// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

// ** Styled Component
import Text from "components/typography/Text";
import Block from "components/layout/Block";
import Toggle from "components/layout/Toggle";

// ** Custom Hooks
import useDarkMode from "hooks/useDarkMode";

const StyledBlock = styled(Block)`
	display: flex;
	max-width: 100%;
	width: fit-content;
	max-width: 100%;
	align-items: center;
	padding: 0.25rem 0.5rem;
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.element};
	user-select: none;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme: { colors } }) => colors.itemsHover};
	}

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}
`;

export const ToggleThemeButton = ({ customMargin }) => {
	const { t } = useTranslation(["common"]);

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode,
	);

	const { toggleTheme } = useDarkMode();

	return (
		<StyledBlock onClick={() => toggleTheme()} $customMargin={customMargin}>
			<Text color="grey" size="0.9rem" mr={2}>
				{t("common:darkMode")}
			</Text>
			<Block flex style={{ height: "19px", alignItems: "center" }}>
				<Toggle toggled={isDarkMode} />
			</Block>
		</StyledBlock>
	);
};
